export default __webpack_public_path__ + "static/media/sidebar-3.79cb8796.jpg";